import { STORAGE_KEY, DEFAULT_BLOCK_NAMES } from "./geo/blocks";
import type { CaptureNotebook } from "./types";

function emptyNotebook(): CaptureNotebook {
  return {
    blockNames: [...DEFAULT_BLOCK_NAMES],
    blocks: [],
    updatedAt: new Date().toISOString(),
  };
}

export function loadNotebook(): CaptureNotebook {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return emptyNotebook();
    const parsed = JSON.parse(raw) as Partial<CaptureNotebook>;
    return {
      blockNames: Array.isArray(parsed.blockNames)
        ? parsed.blockNames.filter((n) => typeof n === "string")
        : [...DEFAULT_BLOCK_NAMES],
      blocks: Array.isArray(parsed.blocks) ? (parsed.blocks as CaptureNotebook["blocks"]) : [],
      updatedAt: typeof parsed.updatedAt === "string" ? parsed.updatedAt : new Date().toISOString(),
    };
  } catch {
    return emptyNotebook();
  }
}

export function saveNotebook(notebook: CaptureNotebook): void {
  const next = { ...notebook, updatedAt: new Date().toISOString() };
  localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
}

export function clearNotebook(): void {
  localStorage.removeItem(STORAGE_KEY);
}